// extracted by mini-css-extract-plugin
module.exports = {"h1":"Heading_h1__evKNd","h2":"Heading_h2__vlNl1","h3":"Heading_h3__49Xke","h4":"Heading_h4__EatB1","h5":"Heading_h5__GFC_g","h6":"Heading_h6__zGNw4"};